import React, { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { getAgent } from "../../redux/actions/agents";
import { changeNotificationReadStatus } from "../../redux/actions/notifications";
import { useDispatch, useSelector } from "react-redux";
import formatDate from "../../../utils/helpers";
import { ExclamationIcon } from "@heroicons/react/solid";

const statusStyles = {
  green: "bg-green-50 text-green-800",
  yellow: "bg-yellow-50 text-yellow-800",
  red: "bg-red-50 text-red-800",
};

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function Detail() {
  const { id } = useParams();
  const dispatch = useDispatch();

  const { agent } = useSelector((state) => state.agents);
  const { notifications } = useSelector((state) => state.notifications);

  const notification = notifications.filter(
    (notification) => notification.id === parseInt(id)
  )[0];

  useEffect(() => {
    dispatch(changeNotificationReadStatus({ id }));
  }, [dispatch, id]);

  useEffect(() => {
    if (notification) {
      dispatch(getAgent({ id: notification.attributes.agentId }));
    }
  }, [dispatch, notification]);

  console.log(agent);

  return (
    <>
      {agent !== null && (
        <div
          key={notification.id}
          className="bg-white px-4 py-6 shadow sm:rounded-lg sm:px-6"
        >
          <div className="sm:flex sm:justify-between sm:items-baseline">
            <h3 className="text-base font-light">
              <span className="text-gray-900">
                {" "}
                From{" "}
                <span
                  className={classNames(
                    statusStyles[notification.attributes.prevStatus],
                    "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium capitalize"
                  )}
                >
                  {notification.attributes.prevStatus}
                </span>{" "}
                to{" "}
                <span
                  className={classNames(
                    statusStyles[notification.attributes.newStatus],
                    "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium capitalize"
                  )}
                >
                  {notification.attributes.newStatus}
                </span>
              </span>
            </h3>
            <p className="mt-1 text-sm text-gray-600 whitespace-nowrap sm:mt-0 sm:ml-3">
              <time dateTime={notification.attributes.createdAt}>
                {formatDate(notification.attributes.createdAt)}
              </time>
            </p>
          </div>
          <div className="mt-4 space-y-6 text-sm text-gray-800">
            <div>
              <div className="font-light text-gray-700">
                Agent name:{" "}
                <span className="font-normal text-sky-800">
                  <Link to={`/admin/agent/${agent.id}`}>
                    {agent.attributes.name}
                  </Link>
                </span>
              </div>
              <div className="font-light text-gray-700">
                Current loan:{" "}
                <span className="font-normal text-sky-800">
                  {agent.attributes.loan} ETB
                </span>
              </div>
            </div>
            <div
              className={classNames(
                statusStyles[notification.attributes.newStatus],
                " p-4 rounded-md"
              )}
            >
              <div className="flex">
                <div className="flex-shrink-0">
                  <ExclamationIcon
                    className={classNames(
                      statusStyles[notification.attributes.newStatus],
                      "h-5 w-5 "
                    )}
                    aria-hidden="true"
                  />
                </div>
                <div className="ml-3">
                  <h3
                    className={classNames(
                      statusStyles[notification.attributes.newStatus],
                      " text-sm font-medium"
                    )}
                  >
                    Reason for status change
                  </h3>
                  <div
                    className={classNames(
                      statusStyles[notification.attributes.newStatus],
                      "mt-2 text-sm"
                    )}
                  >
                    <p>{notification.attributes.reason}</p>
                  </div>
                  <div className="mt-4">
                    <div className="-mx-2 -my-1.5 flex">
                      <Link
                        to={`/admin/agent/${agent.id}`}
                        className={classNames(
                          statusStyles[notification.attributes.newStatus],
                          `border shadow px-2 py-1.5 rounded-md text-sm font-medium hover:bg-${notification.attributes.newStatus}-100`
                        )}
                      >
                        View agent detail
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
